// Обработчики боковых панелей, режима презентации, меню источников.

import { autoConfigureDashboardLayout } from '../canvas';
import { controls } from '../controls';
import { loadIndicatorSections, populateIndicators } from '../indicators';
import { refreshEmissRequestLog } from '../emiss';
import { setBuilderOpen, setFilterbarOpen, setPaletteOpen, setSourcesMenuOpen, setViewMode } from '../workspace';
import { state } from '../state';
import { updateIndicatorControls } from '../widget-form';

export function bindWorkspaceEvents(): void {
  controls.togglePalette.addEventListener('click', () => setPaletteOpen(false));
  controls.showPalette.addEventListener('click', () => setPaletteOpen(true));
  controls.toggleBuilder.addEventListener('click', () => setBuilderOpen(!state.builderOpen));
  controls.closeBuilder.addEventListener('click', () => setBuilderOpen(false));
  controls.builderBackdrop.addEventListener('click', () => {
    setBuilderOpen(false);
    setPaletteOpen(false);
  });
  controls.viewModeButton.addEventListener('click', () => setViewMode(true));
  controls.toggleViewMode.addEventListener('click', () => setViewMode(!state.viewMode));
  controls.canvasHeader.addEventListener('dblclick', () => {
    if (state.viewMode) setViewMode(false);
  });
  controls.toggleFilterbar.addEventListener('click', () => setFilterbarOpen(!state.filtersOpen));
  controls.sourcesMenuButton.addEventListener('click', () => setSourcesMenuOpen(!state.sourcesMenuOpen));
  controls.sourcesEmissCatalog.addEventListener('click', () => {
    setSourcesMenuOpen(false);
    setViewMode(false);
    controls.source.value = 'emiss';
    setPaletteOpen(true);
    void loadIndicatorSections().then(() => {
      populateIndicators();
      void updateIndicatorControls();
    });
  });
  controls.sourcesEmissLog.addEventListener('click', () => {
    setSourcesMenuOpen(false);
    controls.emissDialog.showModal();
    void refreshEmissRequestLog();
  });
  document.addEventListener('click', (event) => {
    if (!state.sourcesMenuOpen) return;
    const target = event.target as Element;
    if (!target.closest('.sources-menu-shell')) setSourcesMenuOpen(false);
  });
  controls.compactLayout.addEventListener('click', autoConfigureDashboardLayout);
}
